import { render, staticRenderFns } from "./LayoutTemplateGetModal.vue?vue&type=template&id=37be3d49"
import script from "./LayoutTemplateGetModal.vue?vue&type=script&lang=js"
export * from "./LayoutTemplateGetModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports